var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      { staticClass: "text-right mt-3" },
      [
        _vm.showRestartStatus
          ? _c("action-button", {
              staticClass: "btn-block-xs-only mr-3",
              attrs: {
                i: "fas fa-undo",
                text: "Regresar Estatus",
                variant: "outline-success"
              },
              on: { click: _vm.restartEstatusHandler }
            })
          : _vm._e(),
        _vm.showRemoveFiles
          ? _c("action-button", {
              staticClass: "outline-danger btn-block-xs-only mr-3",
              attrs: {
                i: "fas fa-times-circle",
                text: "Eliminar Archivos de Pagos"
              },
              on: { click: _vm.removeFilesHandler }
            })
          : _vm._e()
      ],
      1
    ),
    _c("div", { staticClass: "container-fluid mx-0 px-0 w-100" }, [
      _c("div", { staticClass: "row no-gutters" }, [
        _c(
          "div",
          { class: _vm.isThisJornalPaid ? "col-md-8" : "col-md-12" },
          [
            _c("section-title", {
              attrs: { "has-line": "", title: "Información de Jornal" }
            })
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "col-md-4 d-flex justify-content-md-end mb-4 mb-md-0"
          },
          [
            _vm.isThisJornalPaid
              ? [
                  _c("span", { staticClass: "d-flex align-items-center" }, [
                    _c(
                      "label",
                      {
                        staticClass:
                          "color-secondary-6 font-14 font-weight-normal mb-0 mr-1"
                      },
                      [_vm._v(" Fecha Pagado: ")]
                    ),
                    _c("span", [
                      _vm._v(_vm._s(_vm._f("date")(_vm.value.paymentDate)))
                    ])
                  ])
                ]
              : _vm._e()
          ],
          2
        )
      ])
    ]),
    _c("div", { staticClass: "bg-secondary-3 rounded p-2" }, [
      _c("div", { staticClass: "row mt-2 mb-1 mx-1" }, [
        _c("div", { staticClass: "col-6 col-md-3" }, [
          _c("div", { staticClass: "d-flex align-items-center" }, [
            _vm._m(0),
            _c("div", [
              _c(
                "div",
                { staticClass: "color-gray-6 font-14 font-weight-normal" },
                [_vm._v(" Número de Jornal: ")]
              ),
              _c(
                "div",
                { staticClass: "color-black font-weight-bold font-16 mt-1" },
                [_vm._v(" " + _vm._s(_vm.value.paymentJournalNumber) + " ")]
              )
            ])
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-3 mt-3 mt-md-0" }, [
          _c(
            "div",
            { staticClass: "color-gray-6 font-14 font-weight-normal" },
            [_vm._v(" Estatus de Jornal: ")]
          ),
          _c(
            "div",
            { staticClass: "color-black font-weight-bold font-16 mt-1" },
            [
              _c("i", {
                staticClass: "fas fa-circle mr-1",
                class: `color-${_vm.getStatusColor(
                  _vm.value.paymentJournalStatusId
                )}`
              }),
              _vm._v(" " + _vm._s(_vm.value.paymentJournalStatusName) + " ")
            ]
          )
        ]),
        _c("div", { staticClass: "col-6 col-md-3 mt-3 mt-md-0" }, [
          _c(
            "div",
            { staticClass: "color-secondary-6 font-14 font-weight-normal" },
            [_vm._v(" Fecha Creado: ")]
          ),
          _c(
            "div",
            { staticClass: "color-black font-weight-bold font-16 mt-1" },
            [_vm._v(" " + _vm._s(_vm._f("date")(_vm.value.createDate)) + " ")]
          )
        ]),
        _vm.showJournalType
          ? _c(
              "div",
              {
                staticClass:
                  "col-6 col-md-3 d-flex align-items-center justify-content-end mt-3 mt-md-0"
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "journal-type-badge",
                    class: _vm.getJournalTypeClass(
                      _vm.value.paymentJournalTypeId
                    )
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.getJournalTypeLabel(
                            _vm.value.paymentJournalTypeId
                          )
                        ) +
                        " "
                    )
                  ]
                )
              ]
            )
          : _vm._e()
      ]),
      _c("div", { staticClass: "row my-2 py-3 rounded bg-white mx-1" }, [
        _c("div", { staticClass: "col-6 col-md-3" }, [
          _c("div", { staticClass: "journal-icon-offset" }, [
            _c(
              "div",
              { staticClass: "color-secondary-6 font-14 font-weight-normal" },
              [_vm._v(" Pagos: ")]
            ),
            _c(
              "div",
              { staticClass: "color-black font-weight-bold font-16 mt-1" },
              [_vm._v(" " + _vm._s(_vm.value.paymentCount) + " ")]
            )
          ])
        ]),
        _c("div", { staticClass: "col-6 col-md-3" }, [
          _c(
            "div",
            { staticClass: "color-secondary-6 font-14 font-weight-normal" },
            [_vm._v(" Procesado: ")]
          ),
          _c(
            "div",
            { staticClass: "color-black font-weight-bold font-16 mt-1" },
            [
              _vm._v(
                " " + _vm._s(_vm._f("price")(_vm.value.processedAmount)) + " "
              )
            ]
          )
        ]),
        _c("div", { staticClass: "col-6 col-md-3 mt-3 mt-md-0" }, [
          _c(
            "div",
            { staticClass: "color-secondary-6 font-14 font-weight-normal" },
            [_vm._v(" Pendiente: ")]
          ),
          _c(
            "div",
            { staticClass: "color-black font-weight-bold font-16 mt-1" },
            [
              _vm._v(
                " " + _vm._s(_vm._f("price")(_vm.value.pendingAmount)) + " "
              )
            ]
          )
        ]),
        _c(
          "div",
          {
            staticClass:
              "col-6 col-md-3 d-flex justify-content-end mt-3 mt-md-0"
          },
          [
            _c("div", { staticClass: "journal-total-content" }, [
              _c(
                "div",
                { staticClass: "color-secondary-6 font-14 font-weight-normal" },
                [_vm._v(" Total: ")]
              ),
              _c(
                "div",
                { staticClass: "color-black font-weight-bold font-16 mt-1" },
                [
                  _vm._v(
                    " " +
                      _vm._s(_vm._f("price")(_vm.value.paymentTotalAmount)) +
                      " "
                  )
                ]
              )
            ])
          ]
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "journal-icon-dot" }, [
      _c("img", {
        staticClass: "journal-icon-img",
        attrs: { alt: "", src: require("@/assets/img/invoice-file.svg") }
      })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }